import { Chip } from '@pets-ui/Chip/Chip'
import { HStack } from '@pets-ui/HStack/HStack'
import { useTranslation } from 'react-i18next'
import cartUiI18nInstance from '../i18n/i18nConfig'

export interface CouponListItemChipsProps {
  isEnding?: boolean
  isNewCoupon?: boolean
  isNewCustomerOnly?: boolean
  isOldCustomerOnly?: boolean
}

export const CouponListItemChips = (props: CouponListItemChipsProps) => {
  const { isEnding, isNewCoupon, isNewCustomerOnly, isOldCustomerOnly } = props
  const { t } = useTranslation('cartUi', { i18n: cartUiI18nInstance })

  return (
    <HStack gap={1}>
      {isEnding && (
        <Chip
          variant="square"
          size="small"
          color="red"
        >
          {t('cartUi.endingSoon', { defaultValue: '即將結束' })}
        </Chip>
      )}
      {isNewCoupon && (
        <Chip
          variant="square"
          size="small"
          color="red"
        >
          {t('cartUi.newOffer', { defaultValue: '新優惠' })}
        </Chip>
      )}
      {isNewCustomerOnly && (
        <Chip
          variant="square"
          size="small"
          color="blueGrey"
        >
          {t('cartUi.newCustomerOnly', { defaultValue: '新客限定' })}
        </Chip>
      )}
      {isOldCustomerOnly && (
        <Chip
          variant="square"
          size="small"
          color="blueGrey"
        >
          {t('cartUi.returningCustomersOnly', { defaultValue: '舊客限定' })}
        </Chip>
      )}
    </HStack>
  )
}
